export default "__VITE_ASSET__BgD8pPUR__"